var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPill = function SvgIconPill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.236 9.022a1 1 0 0 0-1.378-1.45L14.32 9.035a1 1 0 0 0 1.379 1.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.206 11.203 15.76 15.65a1 1 0 0 1-.111.112l-4.438 4.438a5.245 5.245 0 0 1-7.418.003 5.245 5.245 0 0 1 .003-7.417l8.996-8.996a5.245 5.245 0 0 1 7.417-.003 5.245 5.245 0 0 1-.003 7.417M5.211 14.2a3.245 3.245 0 0 0-.003 4.589 3.245 3.245 0 0 0 4.588-.003l3.787-3.787-4.586-4.586zm5.2-5.201 4.586 4.586 3.795-3.795a3.245 3.245 0 0 0 .003-4.589 3.245 3.245 0 0 0-4.589.003z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPill;